import * as Actions from '../Actions/ComunicadorActions';
import _ from 'lodash';

const initialState = {
    data: null,
    central: null,
    error: null,
    warning: null,
    info: null,
    dialog: null,
    perfis: null,
    destinatarios: null,
    grupospermissao: null,
    timestamp: null,
    open: null,
    preload: false,
    pagina: 1,
    paginas: 1,
};

const ComunicadorReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_MENSAGENS:
            {
                let APayload = [];
                if (!_.isNull(action.payload)) {
                    APayload = action.payload;
                }
                const ANewData = !_.isNull(state.data) ? _.concat(state.data, APayload) : APayload;
                return {
                    ...state,
                    data: _.uniqWith(ANewData, (x, y) =>
                        x.idmensagem === y.idmensagem &&
                        x.idlocal === y.idlocal
                    ),
                    timestamp: new Date().getTime(),
                    preload: false,
                };
            }
        case Actions.GET_MENSAGENS_CENTRAL:
            {
                let APaginas = state.paginas;
                if (action.pagina === 1 && !_.isNull(action.payload)) {
                    APaginas = _.find(action.payload, x => !_.isNull(x.paginas)).paginas;
                }

                return {
                    ...state,
                    central: action.pagina > 1 ? _.concat(state.central, action.payload) : action.payload,
                    paginas: APaginas,
                    timestamp: new Date().getTime(),
                    pagina: action.pagina,
                    paginas: APaginas,
                    preload: false,
                };
            }
        case Actions.GET_MENSAGEM_OPEN:
            {
                return {
                    ...state,
                    open: !_.isNull(action.payload) ? action.payload[0] : null,
                };
            }
        case Actions.SET_MENSAGEM_OPENED:
            {
                let ACentral = !_.isNull(state.central) ? [...state.central] : [];
                let AData = !_.isNull(state.data) ? [...state.data] : [];
                let AIndex = -1;

                AIndex = _.findIndex(state.central, { "idmensagem": action.idmensagem });
                if (AIndex !== -1) {
                    ACentral[AIndex].lido = 1;
                }
                AIndex = _.findIndex(state.data, { "idmensagem": action.idmensagem });
                if (AIndex !== -1) {
                    AData[AIndex].lido = 1;
                }

                return {
                    ...state,
                    central: ACentral,
                    data: AData
                };
            }
        case Actions.GET_LOCAIS:
            {
                let ALocais = [{ "idlocal": -1, "nome": "Enviados", "slug": "enviados" }];
                if (!_.isNull(action.payload)) {
                    ALocais = _.concat(ALocais, _.orderBy(action.payload, ["lido", "ultimamensagem"], ["asc", "desc"]));
                }
                return {
                    ...state,
                    locais: ALocais,
                };
            }
        case Actions.GET_DESTINATARIOS:
            {
                return {
                    ...state,
                    destinatarios: action.payload,
                };
            }
        case Actions.GET_PERFIS:
            {
                return {
                    ...state,
                    perfis: action.payload,
                };
            }
        case Actions.GET_GRUPOSPERMISSAO:
            {
                return {
                    ...state,
                    grupospermissao: action.payload,
                };
            }
        case Actions.COMUNICADOR_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.COMUNICADOR_INFO:
            {
                return {
                    ...state,
                    info: action.payload
                };
            }
        case Actions.COMUNICADOR_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        case Actions.OPEN_COMUNICADOR_DIALOG:
            {
                return {
                    ...state,
                    dialog: action.payload
                };
            }
        case Actions.OPEN_COMUNICADOR_PRELOAD:
            {
                return {
                    ...state,
                    preload: action.preload
                };
            }
        case Actions.REMOVE_MENSAGEM:
            {
                return {
                    ...state,
                    data: _.filter(state.data, x => x.idmensagem !== action.id)
                };
            }
        default:
            {
                return state;
            }
    }
};

export default ComunicadorReducer;
